import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import CommonTable from "../../../components/comman/CommonTable";
import FilterComponent from "../../../components/comman/FilterComponent";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import MainHeading from "../../../components/comman/MainHeading";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { updateFiltersStates } from "../../../store/actions/UserActions";
import { formatAmount } from "../../../utility/CommonFunctions";

export default function TeamReimbursementForm() {
  const navigate = useNavigate();
  const timeoutId = useRef(null);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const dispatch = useDispatch();
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    userList: [],
    searchQuery: "",
    isInitial: true,
  });

  useEffect(() => {
    GetUserList();
  }, [
    filterDetails?.currentPage,
    pageStates?.searchQuery,
    filterDetails?.pageSize,
    filterDetails?.orderBy,
    filterDetails?.year,
  ]);

  const GetUserList = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_reimbursement +
      "?" +
      MainFilterHandler({
        ...pageStates,
        ...filterDetails,
        sortByDate: [],
        startDate: "",
        endDate: "",
        months: [],
        month: "",
        siteId: "",
      });
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerLedgerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.reimbursementForm?.map((item) => ({
          ...item,
          TotalCredit: formatAmount(item?.totalCreditAmount || 0),
          TotalDebit: formatAmount(item?.totalDebitAmount || 0),
          NetAmount: formatAmount(item?.netAmount || 0),
          siteStatus: item?.status,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          userList: newData,
        }));
        dispatch(
          updateFiltersStates({
            count: response?.data?.pageInfo?.total,
            totalPages: response?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: value,
      })
    );
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      dispatch(updateFiltersStates({ currentPage: 1 }));
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 300);
  };

  const HandleView = (data) => {
    navigate(RoutesLink.team_Reimbursement_Form + `/${data?.id}`, {
      state: data,
    });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "employeeCode", label: "EMP. Code" },
    { value: "name", label: "Name" },
    { value: "phone", label: "Contact No." },
    { value: "TotalCredit", label: "Credit" },
    { value: "TotalDebit", label: "Debit" },
    { value: "NetAmount", label: "Net" },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const sortListSite = {
    // site: pageStates.siteList,
    isShow: true,
  };

  const handleData = (data, type = null) => {
    setPageStates((pre) => ({
      ...pre,
      ...(type == "site" && { siteId: data?.site }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
      })
    );
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
    { value: "highest_net", name: "Highest Net Amount" },
    { value: "lowest_net", name: "Lowest Net Amount" },
  ];

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
      })
    );
  };

  return (
    <>
      <>
        <div className="content">
          <MainHeading title={"Team Reimbursement Form"}
            handleYearChange={handleYearChange}

          />
          <div className="card mb-4">
            <div className="card-body">
              <FilterComponent
                handleSearch={handleSearchChange}
                filterArray={sortListSite}
                handleData={handleData}
                hideAllSiteOption={false}
                orderByHandler={orderByHandler}
                orderByList={orderByList}
              // getSite={GetSiteList}
              // pageStates={pageStates}
              />
              <CommonTable
                TableHeading={TableHeading}
                TableData={pageStates?.userList}
                ActionData={ActionData}
                currentPage={filterDetails?.currentPage}
                PageChangeHandler={PageChangeHandler}
                isLoading={pageStates?.tableLoader}
                totalPages={filterDetails?.totalPages}
                count={filterDetails?.count}
                handleChangePageSize={handleChangePageSize}
                pageSize={filterDetails?.pageSize}
              />
            </div>
          </div>
        </div>
      </>
    </>
  );
}
